import React from 'react';
import { motion } from 'framer-motion';
const COLUMNS = [{
  heading: 'El hábito que más importa',
  text: 'La investigación de Lifeway sobre familias cristianas identificó la lectura regular de la Biblia en la infancia como el factor de mayor influencia en la salud espiritual adulta.'
}, {
  heading: 'El formato que engancha a los que “no leen”',
  text: 'Los estudios sobre lectura coinciden: la novela gráfica logra que los lectores reticentes lean más, mejoren su actitud hacia la lectura — y terminen leyendo también más libros de texto tradicional.'
}, {
  heading: 'Probado por millones de familias',
  text: 'Las Biblias en formato cómic ya fueron traducidas a decenas de idiomas y adoptadas por familias, iglesias y catequistas en todo el mundo.'
}];
export function AuthoritySection() {
  return <section className="w-full bg-white" data-id="element-21" data-mp="syt7ijfxnqle">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-22" data-mp="oy9cpmiu0z2f">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[38px]" data-id="element-23" data-mp="oysrwvh3l9cr">
          No es magia. Es cómo aprenden los niños de esta generación.
        </h2>

        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-24" data-mp="34ptzvdf3zyta">
          {COLUMNS.map((col, i) => <motion.div key={col.heading} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="border-t-2 border-gold pt-5" data-id="element-25" data-mp="2uy7g2sopgrex" data-mpi={i}>
              <h3 className="font-display text-xl font-bold text-deep-blue" data-id="element-26" data-mp="39nn5a48l8osi">
                {col.heading}
              </h3>
              <p className="mt-2 text-[16px] text-ink/75" data-id="element-27" data-mp="3dne2apopk15h">{col.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}